import * as stuffTypes from './stuff.type';

export const listSelectedStuffs = selectedStuffs => {
  return {
    type: stuffTypes.LIST_SELECTED_STUFFS,
    payload: selectedStuffs,
  };
};
